function validateKey(event) {
  // Get the key that was pressed
  const key = event.key;

  // Allow backspace, delete, tab, escape, and enter
  if (
    event.key === 'Backspace' ||
    event.key === 'Delete' ||
    event.key === 'Tab' ||
    event.key === 'Escape' ||
    event.key === 'Enter' ||
    // Allow Ctrl+A, Ctrl+C, Ctrl+V for paste functionality
    (event.ctrlKey === true && event.key === 'a') ||
    (event.ctrlKey === true && event.key === 'c') ||
    (event.ctrlKey === true && event.key === 'v')
  ) {
    return true;
  }

  // Allow numbers and a single decimal point
  if (key === '.' && event.target.value.indexOf('.') === -1) {
    return true;
  }

  // If the key is not a number, prevent its input
  if (isNaN(key) && key !== '.') {
    event.preventDefault();
    return false;
  }
}
